import { render } from "./PriceDropLabel.vue?vue&type=template&id=33b257ff"
import script from "./PriceDropLabel.vue?vue&type=script&lang=js"
export * from "./PriceDropLabel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
